module.exports = __webpack_public_path__ + "static/why-3-16a1332f16e0cd423d492fe8847b1ef9.png";